import { debug as logDebug } from 'loglevel';

export enum Key {
  guidelinesDismissed = '__hu__gl_dismissed__',
  featuredPostsDismissed = '__hu__fp_dismissed__',
  featuredPostUniqueImpressions = '__hu__fp_uniqueimpression__',
  showImagesPreference = '__hu__show_images__',
  showSavedPostModalPreference = '__hu__show_save_post_modal__',
  showFloatingBox = '__hu_show_floating_box__',
  hideTakeProfileSurveyModal = '__hu_hide_take_profile_survey_modal__',
  lastViewedPost = '__hu_last_post__',
  marketingOptinPromptDate = '__hu_marketing_optin_prompt_date__',
}

export const getLocalStorageItem = (key: Key) => {
  try {
    if (window?.localStorage) {
      return localStorage.getItem(key);
    }
  } catch (e) {
    logDebug(e);
    return null;
  }
};

export const setLocalStorageItem = (key: Key, value: string) => {
  try {
    if (window?.localStorage) {
      localStorage.setItem(key, value);
    }
  } catch (e) {
    logDebug(e);
  }
};
